// extracted by mini-css-extract-plugin
export var carrierTab = "_4y-0";
export var carrierTabActive = "_4y-1 _4y-0";
export var carrierTabInactive = "_4y-2 _4y-0";
export var carrierTabLabel = "_4y-3";
export var carrierTabLabelActive = "_4y-4 _4y-3";
export var carrierTabLabelInactive = "_4y-5 _4y-3";
export var carrierTabPercentage = "_4y-6";
export var carrierTabPercentageActive = "_4y-7 _4y-6";
export var carrierTabPercentageInactive = "_4y-8 _4y-6";
export var carrierTabWinnable = "_4y-9";
export var carrierTabWinnableActive = "_4y-a _4y-9";
export var carrierTabWinnableInactive = "_4y-b _4y-9";
export var comparisonContainer = "_4y-d";
export var missingRateButton = "_4y-n";
export var missingRateButtonActive = "_4y-o _4y-n";
export var missingRateButtonInactive = "_4y-p _4y-n";
export var missingRateButtonLabel = "_4y-q";
export var missingRateButtonLabelActive = "_4y-r _4y-q";
export var missingRateButtonLabelInactive = "_4y-s _4y-q";
export var sidebar = "_4y-c";
export var strategyButton = "_4y-e";
export var strategyButtonActive = "_4y-f _4y-e";
export var strategyButtonDescription = "_4y-k";
export var strategyButtonDescriptionActive = "_4y-l _4y-k";
export var strategyButtonDescriptionInactive = "_4y-m _4y-k";
export var strategyButtonInactive = "_4y-g _4y-e";
export var strategyButtonLabel = "_4y-h";
export var strategyButtonLabelActive = "_4y-i _4y-h";
export var strategyButtonLabelInactive = "_4y-j _4y-h";
export var unitToggleButton = "_4y-t";
export var unitToggleButtonActive = "_4y-u _4y-t";
export var unitToggleButtonInactive = "_4y-v _4y-t";
export var unitToggleButtonLabel = "_4y-w";
export var unitToggleButtonLabelActive = "_4y-x _4y-w";
export var unitToggleButtonLabelInactive = "_4y-y _4y-w";